import {ArrowLeftOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined} from "@ant-design/icons";
import type {SessionUser} from "@nlrm/api-client";
import {actingRole} from "@nlrm/api-client";
import {Avatar, Button, Layout, Menu, Space, Tag, Typography} from "antd";
import type {MenuProps} from "antd";
import type {ReactNode} from "react";
import {useState} from "react";

const {Header, Sider, Content} = Layout;

export interface ShellNavItem {
  key: string;
  label: string;
  icon?: ReactNode;
  onClick: () => void;
}

interface AppShellProps {
  systemName: string;
  systemSubtitle: string;
  user: SessionUser;
  activeKey: string;
  navItems: ShellNavItem[];
  onLogout: () => void | Promise<void>;
  children: ReactNode;
  actions?: ReactNode;
}

export function AppShell(props: AppShellProps) {
  const [collapsed, setCollapsed] = useState(false);
  const menuItems: MenuProps["items"] = props.navItems.map((item) => ({key: item.key, label: item.label, icon: item.icon}));
  return (
    <Layout className="nlrm-app-shell">
      <Layout>
        <Sider
          width={250}
          collapsedWidth={76}
          collapsed={collapsed}
          breakpoint="lg"
          onCollapse={setCollapsed}
          className="nlrm-sider"
        >
          <div className="shell-brand">
            <img src="/assets/favicon.png" alt="NLRM" />
            {!collapsed && <div><strong>{props.systemName}</strong><span>{props.systemSubtitle}</span></div>}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[props.activeKey]}
            items={menuItems}
            onClick={({key}) => props.navItems.find((item) => item.key === key)?.onClick()}
          />
          <div className="sider-footer">
            <Button type="text" icon={<ArrowLeftOutlined />} href="/">{collapsed ? "" : "返回服务平台"}</Button>
          </div>
        </Sider>
        <Layout>
          <Header className="shell-header">
            <Button
              className="collapse-button"
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed((value) => !value)}
              aria-label={collapsed ? "展开导航" : "收起导航"}
            />
            <Space className="header-actions" size="middle">
              {props.actions}
              <Tag color={actingRole(props.user) === "admin" ? "blue" : "default"}>
                {actingRole(props.user) === "admin" ? "管理员身份" : "常规用户身份"}
              </Tag>
              <Space size={8}>
                <Avatar>{(props.user.name || props.user.email).slice(0, 1).toUpperCase()}</Avatar>
                <div className="user-summary">
                  <Typography.Text strong>{props.user.name || props.user.email}</Typography.Text>
                  <Typography.Text type="secondary">{props.user.email}</Typography.Text>
                </div>
              </Space>
              <Button icon={<LogoutOutlined />} onClick={() => void props.onLogout()}>退出</Button>
            </Space>
          </Header>
          <Content className="shell-content">{props.children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
}
